var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 7.28667V9.95333L8.00033 12.5L12.667 9.95333V7.28667L8.00033 9.83333L3.33366 7.28667ZM8.00033 0.5L0.666992 4.5L8.00033 8.5L14.0003 5.22667V9.83333H15.3337V4.5L8.00033 0.5Z",
    fill: "#7F56D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPurple);
export default __webpack_public_path__ + "static/media/student-purple.35785800f7d23ff833353ca494565a63.svg";
export { ForwardRef as ReactComponent };